import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    let role = "client";
    try { role = sessionStorage.getItem("99t_auth_role") || "client"; } catch (e) {}
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const u = await api.googleSession(sessionId, role);
        setUser(u);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(u.role === "tester" ? "/tester" : "/dashboard", { replace: true });
      } catch (e) {
        setError(true);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="auth-wrap">
      <div className="auth-card" data-testid="auth-callback">
        {error ? (
          <>
            <h1 className="auth-title">Sign-in failed</h1>
            <p className="auth-sub">We couldn't complete Google sign-in. Please try again.</p>
            <a className="btn blue auth-submit" href="/login">Back to sign in</a>
          </>
        ) : (
          <p className="auth-sub" data-testid="auth-callback-loading">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
